import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ModalOverlayWithoutClose,
  Paragraph,
} from '@sentara-health/optimahealth_web';

export interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}


const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  onClose,
  message,
}) => {
  const { t } = useTranslation();

  const displayMessage = message || t('common.internalServerError');

  return (
    <ModalOverlayWithoutClose
      isOpen={isOpen}
      overlayInfo="Error modal information"
    >
      <div data-testid="error-modal-content" className="text-center">
        <Paragraph
          text={displayMessage}
          variant="regular"
          data-testid="error-modal-message"
          className="mb-4"
        />
        <div className="d-flex justify-content-center">
          <Button
            dataTestId="error-modal-ok-button"
            variant="primary_btn"
            onClick={onClose}
          >
            {t('common.ok')}
          </Button>
        </div>
      </div>
    </ModalOverlayWithoutClose>
  );
};

export default ErrorModal;
